/**
 * @license
 * Copyright 2018-2021 Streamlit Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { transparentize } from "color2k"
import { colors, tailwindColors } from "../primitives/colors"

export default {
  ...colors,
  bgColor: colors.gray100,
  inputBgColor: colors.gray100,
  secondaryBg: colors.gray85,
  bodyText: colors.gray10,
  warning: colors.yellow90,
  warningBg: transparentize(colors.yellow80, 0.8),
  success: colors.green70,
  successBg: transparentize(colors.green80, 0.8),
  info: colors.blue60,
  infoBg: transparentize(colors.blue70, 0.9),
  danger: colors.red70,
  dangerBg: transparentize(colors.red70, 0.8),
  primary: "#ffc423",
  disabled: colors.gray70,
  sidebarBackgroundFrom: tailwindColors.gray900,
  sidebarBackgroundTo: colors.black,
  lightestGray: tailwindColors.gray800,
  lightGray: colors.gray70,
  gray: colors.gray60,
  darkGray: colors.gray70,
  red: colors.red80,
  blue: colors.blue80,
  green: colors.green80,
  yellow: colors.yellow80,
}
